import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, propTypes as formPropTypes } from 'redux-form';

import DisplayAllotments from './DisplayAllotments';

import { getCurrentAllotments } from '../../gamedayAccount/selectors';
import { saveCurrentAllotments } from '../actions';

import { newAllotmentTypes } from '../../types/allotments';

export const CurrentAllotments = ({
  currentAllotments,
  saveCurrentAllotments,
  submitting,
  valid,
  change,
  reset,
  allotmentForm,
  handleSubmit
}) => {
  const hasDepartments = currentAllotments?.departments && Object.keys(currentAllotments.departments).length;
  const departmentsHaveValues =
    hasDepartments && Object.values(currentAllotments.departments).filter(dept => dept.allotment !== '0.00').length > 0;
  const hasUnalloted = hasDepartments && parseFloat(currentAllotments.unallotedFunds) > 0;

  return (
    <DisplayAllotments
      type='current'
      allotments={currentAllotments}
      allotmentForm={allotmentForm}
      isSetup={currentAllotments && hasUnalloted && !departmentsHaveValues}
      saveAllotments={saveCurrentAllotments}
      submitting={submitting}
      valid={valid}
      change={change}
      reset={reset}
      handleSubmit={handleSubmit}
    />
  );
};

CurrentAllotments.defaultProps = {
  currentAllotments: {}
};

CurrentAllotments.propTypes = {
  ...formPropTypes,
  currentAllotments: newAllotmentTypes,
  saveCurrentAllotments: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  allotmentForm: state.form.allotmentForm,
  currentAllotments: getCurrentAllotments(state)
});

const connector = connect(mapStateToProps, { saveCurrentAllotments });

export default reduxForm({
  form: 'allotmentForm'
})(connector(CurrentAllotments));
